import { createContext, useContext, useEffect, useState } from "react";
import ProblemService from "../services/problem.service";
import { useUser } from "./UserContext";

const ProblemContext = createContext();

const ProblemProvider = ({ children }) => {
  const [problems, setProblems] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { isLoggedIn } = useUser();

  /* useEffect(() => {
      setIsLoading(true);
      ProblemService.getAllProblemTypes().then((response) => {
      setProblems(response.data);
      setIsLoading(false);
    });
  }); */

  useEffect(() => { 
    if(isLoggedIn){
      const loadProblems = async () => { 
        try{
          setIsLoading(true); 
          const response = await ProblemService.getAllProblemTypes();
          setProblems(response.data); 
          setIsLoading(false); 
        }
        catch(error){
          setIsLoading(false);
        } 
      }
      loadProblems();
    }
  }, [isLoggedIn]); 

  return (
    <ProblemContext.Provider
      value={{ problems, setProblems, isLoading, setIsLoading }}
    >
      {children}
    </ProblemContext.Provider>
  );
};

const useProblem = () => {
  const context = useContext(ProblemContext);
  if (context === undefined) {
    throw new Error("useProblem must be used within a ProblemProvider");
  }
  return context;
};

export { ProblemContext, ProblemProvider, useProblem };